export default "/images/slider-3.jpg?4764c4513e063af2221e19936acb64a8";